import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {API_URL} from "../constants";
import redVoteTeam from "../assets/trump-photo.png";
import blueVoteTeam from "../assets/harris-photo.png";
import redTeam from "../assets/trump_red_team.png";
import blueTeam from "../assets/harris_blue_team.png";
import ButtonLarge from "../components/ButtonLarge";
import VoteTweet from "../components/VoteTweet";
import VoteModal from "../components/VoteModal";
import {formatNumberWithCommas} from "../helpers";
import {getVoteGrandPrize} from "../services";
import Preloader from "../components/Preloader";
import useUserStore from "../store/userStore";

const VOTE_POINTS = 20000;

const SelectParty = () => {
  const {isElectionsFinished} = useUserStore();
  const {user, fetchUserOrCreate} = useUserStore();
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [actualGrandPrize, setActualGrandPrize] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const initData = window.Telegram?.WebApp?.initData;

  const fetchVoteData = async () => {
    try {
      const voteData = await getVoteGrandPrize();
      setActualGrandPrize(voteData.actualGrandPrize);
    } catch (error) {
      console.error("Error fetching vote stats:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVoteData();
  }, []);

  useEffect(() => {
    (async () => {
      if (initData) {
        await fetchUserOrCreate(initData);
      } else {
        console.error('Telegram Web App script not loaded');
      }
    })();
  }, [fetchUserOrCreate, initData]);

  const submitTeamHandler = async (e) => {
    e.preventDefault();

    if (selectedTeam) {
      try {
        const response = await axios.request({
          method: 'POST',
          baseURL: API_URL,
          url: '/telegram-users/select-team',
          data: { team: selectedTeam },
          headers: {
            initdata: initData,
            'ngrok-skip-browser-warning': '69420'
          },
        });
        if (response.data.success) {
          setIsModalOpen(true);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    }
  };

  const selectTeam = (team) => {
    setSelectedTeam(team);
  };

  const resetSelection = (e) => {
    if (e.target.closest('.team-card') || e.target.closest('.vote-card')) return;
    setSelectedTeam(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    navigate('/tabs');
  };

  return (
    isElectionsFinished ? (
      <div className="container select-party-container"
           onClick={resetSelection}>
        <div className="select-party-inner-wrap">
          <h1 className="title">Account Setup</h1>
          <h2 className="subtitle">Tap to Select Your Team</h2>
          <div className="team-card-wrap">
            <button
              className={`team-card ${selectedTeam === 'red' ? 'selected' : ''} ${selectedTeam && selectedTeam !== 'red' ? 'zoom-out' : ''}`}
              onClick={() => selectTeam('red')}
            >
              <div className="team-card-inner">
                <h3>Red</h3>
                <div className="image-container">
                  <img src={redTeam} alt="Red Team"/>
                </div>
              </div>
            </button>
            <button
              className={`team-card blue ${selectedTeam === 'blue' ? 'selected' : ''} ${selectedTeam && selectedTeam !== 'blue' ? 'zoom-out' : ''}`}
              onClick={() => selectTeam('blue')}
            >
              <div className="team-card-inner">
                <h3>Blue</h3>
                <div className="image-container">
                  <img src={blueTeam} alt="Blue Team"/>
                </div>
              </div>
            </button>
          </div>
          <ButtonLarge
            onClick={submitTeamHandler}
            disabled={!selectedTeam}
          >
            Continue
          </ButtonLarge>
        </div>
        <VoteModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        >
          {user && <VoteTweet generatedUserId={user.generatedUserId}/>}
        </VoteModal>
      </div>
      ) : (
      <div className="container select-party-container cast-vote"
           onClick={resetSelection}>
        <div className="select-party-inner-wrap">
          <div className="select-party">
            <div className="select-party-title-wrap">
              <p>2024 US PRESIDENTIAL ELECTION BALLOT</p>
            </div>
            <div className="select-party-content">
              <h1 className="title">CAST MY VOTE</h1>
              <h2 className="subtitle">EARN</h2>
              <h3 className="subtitle-second" data-content={`+$${formatNumberWithCommas(VOTE_POINTS)} Pts`}>
                +${formatNumberWithCommas(VOTE_POINTS)} Pts
              </h3>
              <div className="vote-card-wrap">
                <button
                  className={`vote-card ${selectedTeam === 'red' ? 'selected' : ''} ${selectedTeam && selectedTeam !== 'red' ? 'zoom-out' : ''}`}
                  onClick={() => selectTeam('red')}
                >
                  <div className="image-container">
                    <img src={redVoteTeam} alt="Red Team"/>
                  </div>
                  <span className="team-card-btn">Trump</span>
                </button>
                <button
                  className={`vote-card blue ${selectedTeam === 'blue' ? 'selected' : ''} ${selectedTeam && selectedTeam !== 'blue' ? 'zoom-out' : ''}`}
                  onClick={() => selectTeam('blue')}
                >
                  <div className="image-container">
                    <img src={blueVoteTeam} alt="Blue Team"/>
                  </div>
                  <span className="team-card-btn">Harris</span>
                </button>
              </div>
            </div>
            <div className="select-party-content-bottom">
              <p className="select-party-prize-title">Grand Prize</p>
              <p className="select-party-prize-points">{formatNumberWithCommas(actualGrandPrize)} Points</p>
            </div>
          </div>
          <ButtonLarge
            onClick={submitTeamHandler}
            disabled={!selectedTeam}
          >
            Continue
          </ButtonLarge>
        </div>
        <VoteModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        >
          {user && <VoteTweet generatedUserId={user.generatedUserId}/>}
        </VoteModal>
      </div>
    )
  );
};

export default SelectParty;
